import React, { useState, useEffect } from 'react';
import StoreInventoryDisclaimer from './StoreInventoryDisclaimer.jsx';

const StoreInventoryList = (props) => {
  const [detailsExpanded, setDetailsExpanded] = useState(false);
  const [detailsCTA, setDetailsCTA] = useState('See Location Details');

  const openDetails = () => {
    if (detailsExpanded) {
      setDetailsExpanded(false);
      setDetailsCTA('See Location Details');
    } else {
      setDetailsExpanded(true);
      setDetailsCTA('Hide Location Details');
      dataLayer.push({
        event: 'pdp_local_store_availability_storedetails_click',
      });
    }
  };

  const addressClick = () => {
    dataLayer.push({
      event: 'store_address_click',
      store_location: props.store.store_name,
      product_page: window.location.href,
    });
  };

  useEffect(() => {
    dataLayer.push({
      event: 'store_address_impression',
      store_location: props.store.store_name,
      product_page: window.location.href,
    });
  }, []);

  return (
    <div className="StoreInventoryList__container">
      <div className="StoreInventoryList__col">
        <div className="StoreInventoryList__name">{props.store.store_name}</div>
        {detailsExpanded && (
          <div className="StoreInventoryList__details-expanded">
            {props.store.address && (
              <div className="StoreInventoryList__details-block" onClick={addressClick}>
                <a
                  href={`https://maps.google.com/?q=Windsor,${props.store.address.address_line_1},${props.store.address.address_line_2},${props.store.address.city}, ${props.store.address.state}, ${props.store.address.zip_code}`}
                >
                  <p>{props.store.address.address_line_1}</p>
                  <p>{props.store.address.address_line_2}</p>
                  <p>
                    {props.store.address.city}, {props.store.address.state} {props.store.address.zip_code}
                  </p>
                </a>
                {/* <div className="StoreInventoryList__details-phone">
                <a href={`tel:+1${props.store.phone_number.replace(/\D/g,'')}`}>{props.store.phone_number}</a>
                </div> */}
              </div>
            )}
            {props.store.business_hours && props.store.business_hours.length > 0 && (
              <div className="StoreInventoryList__details-block">
                {props.store.business_hours.map((hours, i) => {
                  if (hours.day.indexOf('-') > -1) {
                    return (
                      <div>
                        <p key={props.store.address.city}>{hours.day}</p>
                        <p key={props.store.phone_number}>{hours.hours}</p>
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <p key={props.store.address.address_line_1}>
                          {hours.day} {hours.hours}
                        </p>
                      </div>
                    );
                  }
                })}
              </div>
            )}
          </div>
        )}
        <div className="StoreInventoryList__details-cta" onClick={openDetails}>
          {detailsCTA}
        </div>
      </div>
      <div className="StoreInventoryList__col">
        <div className="StoreInventoryList__quantity">
          {props.store.quantity <= 0 && <span className="StoreInventoryList__quantity-reg">Sold Out</span>}
          {props.store.quantity > 0 && props.store.quantity <= 2 && (
            <span className="StoreInventoryList__quantity-info" data-inventory-disclaimer>
              <span className="StoreInventoryList__quantity-low">{props.store.quantity} Available</span>
              <StoreInventoryDisclaimer />
            </span>
          )}
          {props.store.quantity > 2 && <span className="StoreInventoryList__quantity-reg">Available</span>}
        </div>
        <div className="StoreInventoryList__distance">{props.store.distance.toFixed(2)} miles</div>
      </div>
    </div>
  );
};

export default StoreInventoryList;
